import styled from 'styled-components'

import { hoverSelector, THEME, typeScale } from '../../styles'

const Styled = styled.div`
  padding: 1.6rem 2.4rem 0;
`
Styled.header = styled.div`
  height: auto;
  display: flex;
  flex-flow: row nowrap;
`
Styled.headerScore = styled.img`
  display: block;
  object-fit: contain;
  object-position: center;
  height: 3.6rem;
  margin-right: 0.8rem;

  &:last-child {
    margin-right: 0;
  }
`
Styled.scoreContainer = styled.div`
  padding-bottom: 1.6rem;

  &:last-child {
    padding-bottom: 0;
  }
`
Styled.scoreLabel = styled.p`
  font-weight: bold;
  padding-top: 1.6rem;

  &:first-child {
    padding-top: 0;
  }
`
Styled.providerContainer = styled.div`
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
  padding-top: 1.6rem;
`
Styled.providerLabel = styled.p`
  ${typeScale('caption', { lineHeight: 'normal' })};
  display: inline-block;
  padding-right: 0.8rem;
  color: ${THEME.COLORS.foreground.secondary};
`
Styled.providerLogo = styled.img`
  height: 1.8rem;
  width: auto;
  filter: grayscale(1);
  opacity: 0.7;
  transition:
    filter 0.2s ease-in-out,
    opacity 0.2s ease-in-out;
`
Styled.providerLink = styled.a`
  display: inline-flex;
  justify-content: center;
  align-items: center;

  ${hoverSelector(Styled.providerLogo)`
    filter: grayscale(0);
    opacity: 1;
  `}
`

export default Styled
